module.exports = __webpack_public_path__ + "static/media/get_bg_old.de32827c.jpg";